import { render } from "./Navigation.vue?vue&type=template&id=88e1c930&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=88e1c930&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-88e1c930"

export default script